<template>
  <div class="app-container">
    <div class="screeBox">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="选择园区">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option label="全部园区" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择企业">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.company_id"
            placeholder="请选择企业"
            @change="companyChange"
            :disabled="screen.residence_house_id != ''"
          >
            <!-- @change="companyChange" -->
            <el-option label="全部企业" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in screenCompanyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择住宅">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.residence_house_id"
            placeholder="请选择房间"
            @change="houseChange"
            :disabled="screen.company_id != ''"
          >
            <el-option label="全部住宅" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in houseList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记录类型">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.type"
            placeholder="请选择记录类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="物业费" value="1"></el-option>
            <el-option label="租赁费" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择缴费状态">
          <el-select
            class="screenInput"
            filterable
            v-model="screen.status"
            placeholder="请选择缴费状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="未缴" value="1"></el-option>
            <el-option label="已缴" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记录开始时间">
          <el-date-picker
            value-format="timestamp"
            v-model="screen.start_record_time"
            type="datetime"
            placeholder="选择记录开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="记录结束时间">
          <el-date-picker
            value-format="timestamp"
            v-model="screen.end_record_time"
            type="datetime"
            placeholder="选择记录结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="labName">
          <el-button
            type="primary"
            @click="(screen.page = 1), fetchData()"
            style="margin-bottom: 5px"
            >搜索</el-button
          >
          <el-button
            type="primary"
            plain
            @click="reset()"
            style="margin-bottom: 5px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/property/fee_add')"
        >添加</el-button
      >
      <el-button
        size="medium"
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/property/fee_import_template')"
        >下载模板</el-button
      >
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/property/fee_import')"
        >导入</el-button
      >
      <!-- <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/export')"
        >导出</el-button
      > -->
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column label="所属园区" width="150">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.park ? scope.row.park.name : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="标题" width="80">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "物业费" : "租赁费" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账单所属" width="100">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.belong_to == 1 ? "企业" : "住宅" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属企业/房间" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.belong_to == 1">
            <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
          </span>
          <span v-if="scope.row.belong_to == 2">
            <span v-if="scope.row.residence_house">{{
              scope.row.residence_house.name
            }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="图片" min-width="170">
        <template slot-scope="scope">
          <el-image
          v-if="scope.row.image"
            style="max-width: 150px; height: 80px"
            :src="imageOss + scope.row.image.split(',')[0]"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.image.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="实际费用" width="100">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.price }}</div>
        </template>
      </el-table-column>
      <el-table-column label="记录开始时间" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.start_record_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="记录结束时间" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.end_record_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.des }}</div>
        </template>
      </el-table-column>
      <el-table-column label="缴费状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="info" disable-transitions
            >未缴</el-tag
          >
          <el-tag
            v-if="scope.row.status == 2"
            type="success"
            disable-transitions
            >已缴</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="缴费人" width="120">
        <template slot-scope="scope">
          <div >
            <span>{{
              scope.row.system_admin ? scope.row.system_admin.name : "--"
            }}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="缴费时间" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.pay_time }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button
              size="mini"
              type="warning"
              @click="handleSee(scope.row)"
              v-if="roles.includes('/property/fee_info')"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.row)"
              v-if="roles.includes('/property/fee_edit') && scope.row.status != 2"
              >编辑</el-button
            >
            <el-button
              class="btnTop"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.id)"
              v-if="roles.includes('/property/fee_del')"
              >删除</el-button
            >
          </div>
          <div style="margin-top: 10px" v-if="scope.row.status == 1">
            <el-button
              size="mini"
              type="success"
              @click="affirm(scope.row.id)"
              v-if="
                roles.includes('/property/fee_change_status') &&
                scope.row.status == 1
              "
              >缴费成功</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="150px"
        class="demo-screen"
        :rules="infoRules"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="infoForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see'"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="infoForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="账单所属" prop="belong_to">
          <el-radio-group
            v-model="infoForm.belong_to"
            :disabled="czType == 'see'"
            @input="belongToChange"
          >
            <el-radio :label="1">企业</el-radio>
            <el-radio :label="2">住宅</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="infoForm.belong_to == 1">
          <el-form-item label="选择企业" prop="company_id">
            <el-select
              class="screenInput"
              filterable
              v-model="infoForm.company_id"
              placeholder="请选择企业"
              @change="formCompanyChange"
              :disabled="czType == 'see'"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in formCompanyList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="选择房屋" prop="residence_house_id">
            <el-select
              :key="infoForm.belong_to"
              filterable
              v-model="infoForm.residence_house_id"
              placeholder="请选择房屋"
              multiple
              collapse-tags
            >
              <el-option
                :label="item1.name"
                :value="item1.space_house_id"
                v-for="(item1, index1) in formHouseList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div v-if="infoForm.belong_to == 2">
          <el-form-item label="选择房屋" prop="residence_house_id">
            <el-select
              :key="infoForm.belong_to"
              filterable
              v-model="infoForm.residence_house_id"
              placeholder="请选择房屋"
              :disabled="czType == 'see'"
            >
              <el-option
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in houseList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="记录类型" prop="type">
          <el-radio-group v-model="infoForm.type" :disabled="czType == 'see'">
            <el-radio :label="1">物业费</el-radio>
            <el-radio :label="2">租赁费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="记录开始时间" prop="start_record_time">
          <el-date-picker
            :disabled="czType == 'see'"
            value-format="timestamp"
            v-model="infoForm.start_record_time"
            type="datetime"
            placeholder="选择记录开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="记录结束时间" prop="end_record_time">
          <el-date-picker
            :disabled="czType == 'see'"
            value-format="timestamp"
            v-model="infoForm.end_record_time"
            type="datetime"
            placeholder="选择记录结束时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="价格" prop="price">
          <el-input
            min="0"
            class="w4 numInput"
            :disabled="czType == 'see'"
            v-model="infoForm.price"
            type="Number"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="二次确认标识" prop="flag">
          <el-input
            type="Number"
            min="0"
            class="w4 numInput"
            :disabled="czType == 'see'"
            v-model="infoForm.flag"
          ></el-input>
        </el-form-item> -->
        <el-form-item prop="image" label="图片">
          <el-upload
            :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="czType == 'see'"
            accept=".jpg,.png,.jpeg"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>

        <el-form-item label="描述" prop="des">
          <el-input
            type="textarea"
            class="w4"
            :disabled="czType == 'see'"
            v-model="infoForm.des"
          ></el-input>
        </el-form-item>

        <el-form-item label="缴费状态" prop="status">
          <el-radio-group v-model="infoForm.status" :disabled="czType == 'see'">
            <el-radio :label="1">未缴</el-radio>
            <el-radio :label="2">已缴</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="接收邮箱" prop="head_name">
          <el-input class="w4" disabled v-model="infoForm.email"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="czType == 'edit'"
            type="success"
            @click="editForm('infoForm')"
          >
            编辑
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('infoForm')"
          >
            提交
          </el-button>
          <el-button type="info" @click="drawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/property/fee_import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="fileSuccess"
        :on-progress="fileUpload"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  openPark,
  delImage,
  openCompany,
  get_park_houses,
  openAgoUser,
  get_company_house,
} from "@/api/index";
import { examine } from "@/api/invoice";
import {
  feeLists,
  feeInfo,
  feeEdit,
  feeStatus,
  feeImport,
  feeTemplate,
  feeAdd,
  feeDel,
} from "@/api/property";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      labName: "   ",
      infoForm: {},
      token: getToken(),
      list: [],
      listLoading: true,
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        company_id: "",
        residence_house_id: "",
        type: "",
        status: "",
        belong_to: "",
        start_record_time: "",
        end_record_time: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      drawer: false,
      drawerTitle: "",
      fileList: [],
      multipleSelection: [],
      screenCompanyList: [],
      czType: "see",
      infoRules: {
        park_id: [
          { required: true, message: "请选择园区", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        belong_to: [
          { required: true, message: "请选择账单所属", trigger: "change" },
        ],
        company_id: [
          { required: true, message: "请选择企业", trigger: "change" },
        ],
        residence_house_id: [
          { required: true, message: "请选择房屋", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择记录类型", trigger: "change" },
        ],
        start_record_time: [
          { required: true, message: "请选择记录开始时间", trigger: "change" },
        ],
        end_record_time: [
          { required: true, message: "请选择记录开始时间", trigger: "change" },
        ],
        price: [
          { required: true, message: "请输入价格", trigger: "change" },
        ],
        // image: [
        //   { required: true, message: "请选择封面图", trigger: "change" },
        // ],
        // des: [
        //   { required: true, message: "请输入描述", trigger: "change" },
        // ],
        status: [
          { required: true, message: "请选择缴费状态", trigger: "change" },
        ],
      },
      dialogImageUrl: "",
      houseList: [],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      formCompanyList: [],
      formHouseList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
    this.getParkHouse("screen");
  },
  methods: {
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      
      this.handleInfo(val.id, val.park_id);
      if(val.belong_to == 1){
        this.getCompany("add", val.park_id);
      }else{
        this.getParkHouse("form");
      }
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.handleInfo(val.id, val.park_id);
      this.drawer = true;
    },
     // 查看详情
    handleInfo(id) {
      var that = this;
      feeInfo({
        id: id,
      }).then((res) => {
        that.infoForm = {
          id: res.data.info.id,
          title: res.data.info.title,
            park_id: res.data.info.park_id,
            company_id: res.data.info.company_id,
            // start_record_time: res.data.info.start_record_time * 1000,
            end_record_time: res.data.info.end_record_time,
            type: res.data.info.type,
            status: res.data.info.status,
            price: res.data.info.price,
            flag: 1,
            residence_house_id:res.data.info.residence_house_id,
            belong_to: res.data.info.belong_to,
            des: res.data.info.des,
            image: res.data.info.image,
        };
        console.log(new Date(res.data.info.end_record_time).getTime())
        this.$set(that.infoForm, "start_record_time", new Date(res.data.info.start_record_time).getTime());
        this.$set(that.infoForm, "end_record_time", new Date(res.data.info.end_record_time).getTime());
        if(res.data.info.image){
          var list = res.data.info.image.split(",");
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
        }
        
        if(res.data.info.belong_to == 1){
        this.getCompany("add", res.data.info.park_id);
      }else{
        this.getParkHouse("form");
      }
        console.log(that.infoForm )

      });

      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          feeDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },

    // 切换账单所属
    belongToChange(e) {
      if (e == 1) {
        this.getCompany("add", this.infoForm.park_id);
        this.infoForm.company_id = "";
        this.infoForm.residence_house_id = [];
      } else if (e == 2) {
        this.getParkHouse("form");
        this.infoForm.residence_house_id = "";
      }
    },

    // 提交选择园区
    formParkChange(e) {
      console.log(e);
      this.infoForm.residence_house_id = "";
      this.infoForm.company_id = "";
      if (this.infoForm.belong_to == 2) {
        this.getParkHouse("form");
      } else {
        this.getCompany("add", e);
      }
    },
    // 提交选择企业
    formCompanyChange(e) {
      console.log(e);
      this.infoForm.residence_house_id = [];
      this.getHouse();
    },
    // 添加物业&租赁费用
    addMenu() {
      this.drawerTitle = "添加设备";
      this.czType = "add";
      this.infoForm = {
        title: "",
        park_id: "",
        company_id: "",
        start_record_time: "",
        end_record_time: "",
        type: 1,
        status: "",
        price: "",
        flag: 1,
        residence_house_id: "",
        belong_to: "",
        des: "",
        image: "",
      };
      this.fileList = [];
      this.drawer = true;
    },

    // 重置上传文件
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 导入上传成功
    fileSuccess(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });
        this.$refs.upload.clearFiles();
        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 导入上传进度
    fileUpload(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入开打
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      feeTemplate().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },

    // 搜索企业change
    companyChange() {
      this.screen.residence_house_id = "";
    },
    // 搜索房间change
    houseChange() {
      this.screen.company_id = "";
    },
    // 获取园区住宅列表
    getParkHouse(type) {
      let data = {};
      if (type == "screen") {
        data.park_id = this.screen.park_id;
      } else if (type == "form") {
        data.park_id = this.infoForm.park_id;
      }
      get_park_houses(data).then((res) => {
        this.houseList = res.data;
      });
    },
    // 获取企业房间列表
    getHouse() {
      get_company_house({
        park_id: this.infoForm.park_id,
        company_id: this.infoForm.company_id,
      }).then((res) => {
        this.formHouseList = res.data.lists.data;
      });
    },
    // 选择搜索园区
    parkChange(e) {
      this.screen.residence_house_id = "";
      this.screen.company_id = "";
      this.getCompany("screen", e);
      this.getParkHouse("screen");
    },
    // 表单多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 删除图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 删除图片
    handleRemovePic(file, fileList) {
      this.fileList = fileList;
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.infoForm.image = list.join(",");
    },
    // 上传图片
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.fileList = fileList;
        if (this.infoForm.image) {
          this.delImg(this.infoForm.image);
        }
        this.infoForm.image = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    // 改变状态
    affirm(id) {
      var that = this;
      this.$confirm("是否已缴费成功？")
        .then(() => {
          feeStatus({
            id: id,
            status: 2,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 搜索重置
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        company_id: "",
        residence_house_id: "",
        type: "",
        status: "",
        belong_to: "",
        start_record_time: "",
        end_record_time: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    // 分页
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 添加提交
    submitForm(formName) {
      console.log(this.infoForm);
      // return;
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            title: that.infoForm.title,
            park_id: that.infoForm.park_id,
            company_id: that.infoForm.company_id,
            start_record_time: that.infoForm.start_record_time / 1000,
            end_record_time: that.infoForm.end_record_time / 1000,
            type: that.infoForm.type,
            status: that.infoForm.status,
            price: that.infoForm.price,
            flag: that.infoForm.flag,
            residence_house_id: that.infoForm.residence_house_id,
            belong_to: that.infoForm.belong_to,
            des: that.infoForm.des,
            image: that.infoForm.image,
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
          });
          feeAdd(data).then((res) => {
            loading.close();
            if(res.code == 1100){
              that.infoForm.flag=2
              this.$confirm(res.msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.submitForm('infoForm')
        }).catch(() => {        
        });
            }else
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 编辑提交
    editForm(formName) {
      console.log(this.infoForm);
      // return;
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id:that.infoForm.id,
            title: that.infoForm.title,
            park_id: that.infoForm.park_id,
            company_id: that.infoForm.company_id,
            start_record_time: that.infoForm.start_record_time / 1000,
            end_record_time: that.infoForm.end_record_time / 1000,
            type: that.infoForm.type,
            status: that.infoForm.status,
            price: that.infoForm.price,
            flag: that.infoForm.flag,
            residence_house_id:that.infoForm.residence_house_id,
            belong_to: that.infoForm.belong_to,
            des: that.infoForm.des,
            image: that.infoForm.image,
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
          });
          feeEdit(data).then((res) => {
            loading.close();
            if(res.code == 1100){
              that.infoForm.flag=2
              this.$confirm(res.msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.editForm('infoForm')
        }).catch(() => {        
        });
            }else if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.infoForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },

    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取企业列表
    getCompany(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
          this.screenCompanyList = response.data.lists;
        } else if (type == "add") {
          this.formCompanyList = response.data.lists;
        }
      });
    },
    // 获取列表
    fetchData() {
      this.listLoading = true;
      let data = {
        page: this.screen.page,
        page_size: this.screen.page_size,
        park_id: this.screen.park_id,
        type: this.screen.type,
        company_id: this.screen.company_id,
        residence_house_id: this.screen.residence_house_id,
        status: this.screen.status,
        start_record_time: this.screen.start_record_time
          ? this.screen.start_record_time / 1000
          : "",
        end_record_time: this.screen.end_record_time
          ? this.screen.end_record_time / 1000
          : "",
      };
      // return
      feeLists(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 100px;
  height: 50px;
}
// .screenInput {
//   width: 200px;
//   margin: 0 10px 10px;
// }
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

::v-deep .screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 20%;
    margin-bottom: 0;
    margin-right: 0;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
